// src/components/common/Modal.js

import React from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
        onClick={onClose}
      ></div>

      {/* Modal Content - Responsive Width */}
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-sm sm:max-w-lg md:max-w-xl lg:max-w-2xl mx-auto overflow-hidden transform transition-all">
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 sm:px-6 sm:py-4 bg-gray-100 border-b border-gray-200"> {/* Adjusted padding */}
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900">{title}</h3> {/* Adjusted text size */}
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-md"
            onClick={onClose}
          >
            <span className="sr-only">Close modal</span>
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-4 sm:p-6 max-h-[80vh] overflow-y-auto"> {/* Adjusted padding */}
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
